import { NavigationBar, NavigationLink, useTestId } from '@cmctechnology/phoenix-stockbroking-web-design';
import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { IStore } from '../../Store/Store';
import { NavigationStep } from '../../models/page';
import { pages } from '../../models/pagePaths';
import { BusinessRegion } from '../../configuration/configuration';
import { SgpLogo as SgpLogoBase } from '../SgpLogo';

const SgpLogo = styled(SgpLogoBase)`
  padding-left: 2rem;
`;

export const Navigation = () => {
  const { generateTestId } = useTestId({}, `navigation`);
  const { t } = useTranslation();
  const page = useSelector((store: IStore) => store.local.page);
  const [selectedLink, setSelectedLink] = useState<NavigationStep>();

  useEffect(() => {
    setSelectedLink(pages[page].navigationStep?.(BusinessRegion.SGP) as NavigationStep);
  }, [page]);

  if (!selectedLink) {
    return (
      <NavigationBar>
        <SgpLogo alt={t('CMC Invest')} {...generateTestId(`logo`)} />
      </NavigationBar>
    );
  }

  return (
    <NavigationBar renderLogo={() => <SgpLogo alt={t('CMC Invest')} {...generateTestId(`logo`)} />}>
      <NavigationLink
        selected={selectedLink === NavigationStep.Profile}
        visited={selectedLink === NavigationStep.Identification || selectedLink === NavigationStep.AboutYou || selectedLink === NavigationStep.ReviewAndSubmit}
        label={t('PROFILE')}
      />
      <NavigationLink
        selected={selectedLink === NavigationStep.Identification}
        visited={selectedLink === NavigationStep.AboutYou || selectedLink === NavigationStep.ReviewAndSubmit}
        label={t('IDENTIFICATION')}
        shortLabel={t('ID')}
      />
      <NavigationLink
        selected={selectedLink === NavigationStep.AboutYou}
        visited={selectedLink === NavigationStep.ReviewAndSubmit}
        label={t('ABOUT YOU')}
        shortLabel={t('ABOUT')}
      />
    </NavigationBar>
  );
};
